import { useEffect, useRef } from "react";
import { Typography } from "@repo/design-system";
import SmilesDrawer from "smiles-drawer";
import { MOLECULE_HEIGHT, MOLECULE_WIDTH, truncate } from "../helpers";

interface ISmilesMoleculeProps {
  smiles: string | null;
  id: string | null;
}

export function SmilesMolecule({ smiles, id }: ISmilesMoleculeProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!smiles || !canvasRef.current) return;
    const drawer = new SmilesDrawer.Drawer({
      width: MOLECULE_WIDTH,
      height: MOLECULE_HEIGHT,
      padding: 8,
    });
    SmilesDrawer.parse(
      smiles,
      (tree) => {
        if (canvasRef.current) {
          drawer.draw(tree, canvasRef.current, "light", false);
        }
      },
      () => {},
    );
  }, [smiles]);

  return (
    <div className="flex flex-col items-center gap-1.5">
      {smiles ? (
        <canvas
          ref={canvasRef}
          aria-label="Molecule structure"
          width={MOLECULE_WIDTH}
          height={MOLECULE_HEIGHT}
          className="block"
        />
      ) : (
        <div
          style={{ width: MOLECULE_WIDTH, height: MOLECULE_HEIGHT }}
          className="flex items-center justify-center">
          <Typography
            variant="paragraph-m-regular"
            className="text-contentTertiary">
            —
          </Typography>
        </div>
      )}
      {id ? (
        // A real <a target="_blank"> — never popup-blocked, unlike
        // window.open(). stopPropagation keeps this from also toggling the
        // row's selection.
        <a
          href={`/data/details/${encodeURIComponent(id)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full cursor-pointer"
          onClick={(e) => e.stopPropagation()}>
          <Typography
            variant="paragraph-m-semibold"
            className="text-center text-contentBrand underline-offset-2 hover:underline">
            {truncate(id)}
          </Typography>
        </a>
      ) : null}
    </div>
  );
}
